import { postRequest, getRequest } from "../../utils/apiHelper";
import {
  setProducts,
  appendProducts,
  setLoading,
  setError,
  setProductTypes,
} from "./inventorySlice";

// Thunk to fetch products from the API
export const fetchProductsAPI =
  (requestData, loadMore = false) =>
  async (dispatch) => {
    try {
      if (!loadMore) {
        dispatch(setLoading(true));
      }

      const response = await postRequest(
        `api/ProductService/GetProducts?CompanyId=1`,
        requestData,
      );

      const responseData = response.data || {};

      if (loadMore) {
        dispatch(appendProducts(responseData));
      } else {
        dispatch(setProducts(responseData));
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.Message ||
        error.message ||
        "Failed to fetch products.";
      dispatch(setError(errorMessage));
      console.error("API Error - fetchProductsAPI:", errorMessage);
    } finally {
      if (!loadMore) {
        dispatch(setLoading(false));
      }
    }
  };

// Thunk to fetch product types lookup
export const fetchProductTypesAPI = () => async (dispatch) => {
  try {
    const response = await postRequest(`api/ProductService/GetProducts`);
    dispatch(setProductTypes(response.data || []));
  } catch (error) {
    const errorMessage =
      error.response?.data?.Message ||
      error.message ||
      "Failed to fetch product types.";
    console.error("API Error - fetchProductTypesAPI:", errorMessage);
  }
};
